import React, { useEffect, useRef } from 'react'
import SmoothScrollbar from 'smooth-scrollbar'
import * as styles from './style'

interface Props {
  alwaysShowTracks?: boolean
  children?: React.ReactNode
  continuousScrolling?: boolean
  damping?: number
  renderByPixels?: boolean
}

export default function CustomScrollbar({
  alwaysShowTracks = false,
  children,
  continuousScrolling = true,
  damping = 0.1,
  renderByPixels = true,
}: Props): JSX.Element {
  const elementRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!elementRef || !elementRef.current) return
    const scrollbar = SmoothScrollbar.init(elementRef.current, {
      alwaysShowTracks,
      damping,
      continuousScrolling,
      renderByPixels,
    })
    return () => {
      if (scrollbar) {
        scrollbar.destroy()
      }
    }
  }, [])

  return (
    <section className={styles.root} data-scrollbar ref={elementRef}>
      {children}
    </section>
  )
}
